var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5806 6.21579L6.21668 12.5798C5.99924 12.7972 5.63862 12.7972 5.42119 12.5798C5.20375 12.3623 5.20375 12.0017 5.42119 11.7843L11.7851 5.4203C12.0026 5.20286 12.3632 5.20286 12.5806 5.4203C12.7981 5.63773 12.7981 5.99836 12.5806 6.21579Z",
    fill: "#0A2341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5806 12.5797C12.3632 12.7971 12.0026 12.7971 11.7851 12.5797L5.42119 6.21574C5.20375 5.99831 5.20375 5.63768 5.42119 5.42025C5.63862 5.20281 5.99924 5.20281 6.21668 5.42025L12.5806 11.7842C12.7981 12.0016 12.7981 12.3623 12.5806 12.5797Z",
    fill: "#0A2341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.3f71a1ad150438d979c33b0a0dcdaf91.svg";
export { ForwardRef as ReactComponent };